module.exports = __webpack_public_path__ + "static/media/clock.0812c286.svg";